import Autosuggest from './Autosuggest';
export { Props } from './Autosuggest';
export default Autosuggest;
